import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Renderer2,
} from '@angular/core';

import { deepEqual } from 'fast-equals';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';

import { filterBoolean } from '@recruitee/common';
import {
  ArrowPosition,
  BaseTooltipComponent,
  ComponentTooltipService,
} from '@recruitee/user-interface';

import { FeatureTooltipData } from './../../product-updates.types';

@Component({
  selector: 'rt-feature-tooltip-wrapper',
  templateUrl: './feature-tooltip-wrapper.component.html',
  styleUrls: ['./feature-tooltip-wrapper.component.less'],
})
export class FeatureTooltipWrapperComponent extends BaseTooltipComponent implements OnInit {
  public data: FeatureTooltipData;
  public arrowPosition: ArrowPosition;

  public close$ = new EventEmitter<void>();
  public learnMoreClick$ = new EventEmitter<void>();

  public ngOnDestroy$ = new Subject<void>();

  constructor(
    private cdRef: ChangeDetectorRef,
    private componentTooltipService: ComponentTooltipService<
      typeof FeatureTooltipWrapperComponent,
      FeatureTooltipData
    >,
    elementRef: ElementRef,
    renderer2: Renderer2,
  ) {
    super(elementRef, renderer2);
  }

  public ngOnInit(): void {
    this.componentTooltipService.data$
      .pipe(
        distinctUntilChanged((a, b) => deepEqual(a, b)),
        filterBoolean,
        takeUntil(this.ngOnDestroy$),
      )
      .subscribe(data => {
        this.data = data;
        this.cdRef.detectChanges();
      });
  }

  public updateArrow(arrowPosition: ArrowPosition): void {
    this.arrowPosition = arrowPosition;
  }
}
